import {SidebarLink} from './SidebarLink'
import styles from './SidebarTemplateRepository.module.css'

interface SidebarTemplateRepositoryProps {
  ownerLogin: string
  name: string
  path: string
}

/** Displays "Generated from owner/repo" when the repository was created from a template. */
export function SidebarTemplateRepository({ownerLogin, name, path}: SidebarTemplateRepositoryProps) {
  return (
    <div className={styles.container}>
      <span>
        Generated from{' '}
        <SidebarLink to={path} inline analyticsLabel="section:template-repository" reloadDocument>
          {`${ownerLogin}/${name}`}
        </SidebarLink>
      </span>
    </div>
  )
}
